import Layout from "@/components/Layout";
import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { Truck, Package, MapPin, Clock } from "lucide-react";

export default function Transport() {
  return (
    <Layout>
      <section className="bg-[#3D2314] py-16 md:py-20">
        <div className="max-w-7xl mx-auto px-4 text-center">
          <h1 className="text-3xl md:text-4xl font-bold text-white mb-4 font-display">Henting og levering</h1>
          <p className="text-white/80 max-w-2xl mx-auto">Har du ikke mulighet til å levere selv? Vi kan avtale henting og levering av utstyret ditt i Bergensområdet mot et tillegg.</p>
        </div>
      </section>
      <section className="py-16 md:py-24 bg-[#FFF8F0]">
        <div className="max-w-5xl mx-auto px-4 grid grid-cols-1 md:grid-cols-2 gap-6">
          {[
            { icon: Package, title: "1. Meld inn behov", desc: "Fyll ut innleveringsskjemaet eller kontakt oss, og oppgi at du ønsker henting." },
            { icon: MapPin, title: "2. Vi avtaler tidspunkt", desc: "Vi finner et tidspunkt som passer, og henter utstyret på oppgitt adresse." },
            { icon: Truck, title: "3. Service på verkstedet", desc: "Utstyret diagnostiseres og repareres på verkstedet i Birkeveien 2." },
            { icon: Clock, title: "4. Levering tilbake", desc: "Når arbeidet er ferdig og godkjent, leverer vi utstyret tilbake til deg." },
          ].map((c) => (
            <div key={c.title} className="bg-white rounded-xl p-6 border border-[#D4A574]/20 flex gap-4">
              <div className="shrink-0 w-12 h-12 rounded-full bg-[#D4A574]/15 flex items-center justify-center"><c.icon className="h-6 w-6 text-[#3D2314]" /></div>
              <div><h3 className="font-semibold text-[#3D2314] mb-1">{c.title}</h3><p className="text-sm text-[#1A1A1A]/70">{c.desc}</p></div>
            </div>
          ))}
        </div>
        <div className="max-w-3xl mx-auto px-4 mt-10">
          <div className="bg-amber-50 rounded-xl p-5 border border-amber-200 text-sm text-amber-900">Henting og levering avtales individuelt og kommer i tillegg til servicepakken. Pris avhenger av avstand. Kontakt oss for et konkret tilbud.</div>
          <div className="text-center mt-8"><Button asChild size="lg" className="bg-[#D4A574] hover:bg-[#D4A574]/90 text-[#3D2314] font-semibold"><Link to="/kontakt-skjema">Avtal henting</Link></Button></div>
        </div>
      </section>
    </Layout>
  );
}
